module.exports = __webpack_public_path__ + "static/img/15@2x.e43356b0.png";